import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, createTextVNode as _createTextVNode, Transition as _Transition, vModelText as _vModelText, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "mt-2 text-sm text-gray-700"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-25" }, null, -1)
const _hoisted_6 = { class: "fixed inset-0 z-40 flex" }
const _hoisted_7 = { class: "flex items-center justify-between px-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-medium text-gray-900" }, " Filters ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close menu", -1)
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = { class: "-mx-2 -my-3 flow-root" }
const _hoisted_12 = { class: "font-medium text-gray-900" }
const _hoisted_13 = { class: "ml-6 flex items-center" }
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = ["id", "checked", "indeterminate", "onChange"]
const _hoisted_16 = ["for"]
const _hoisted_17 = { class: "space-y-6 pt-4" }
const _hoisted_18 = ["id", "name", "value", "onUpdate:modelValue"]
const _hoisted_19 = ["for"]
const _hoisted_20 = {
  key: 1,
  "aria-labelledby": "filter-heading"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h2", {
  id: "filter-heading",
  class: "sr-only"
}, " Filters ", -1)
const _hoisted_22 = { class: "flex items-center justify-between" }
const _hoisted_23 = { class: "flext items-center justify-center text-sm font-medium text-gray-700" }
const _hoisted_24 = { class: "space-y-2 divide-y divide-gray-200" }
const _hoisted_25 = { class: "px-3 w-40" }
const _hoisted_26 = ["id", "checked", "indeterminate", "onChange"]
const _hoisted_27 = ["for"]
const _hoisted_28 = { class: "space-y-2 pt-3 px-3" }
const _hoisted_29 = ["id", "name", "value", "onUpdate:modelValue"]
const _hoisted_30 = ["for"]
const _hoisted_31 = {
  key: 0,
  class: "w-full"
}
const _hoisted_32 = { class: "relative mt-3 flex items-center" }
const _hoisted_33 = { class: "absolute items-center left-0 pl-1.5" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, " Search ", -1)
const _hoisted_35 = ["placeholder"]
const _hoisted_36 = { class: "flex flex-col" }
const _hoisted_37 = { class: "" }
const _hoisted_38 = { class: "" }
const _hoisted_39 = { class: "overflow-x-auto md:rounded-lg" }
const _hoisted_40 = { class: "w-full divide-y divide-gray-300 table-fixed" }
const _hoisted_41 = {
  key: 0,
  scope: "col",
  class: "relative items-center sm:w-16 sm:px-3"
}
const _hoisted_42 = ["checked", "indeterminate"]
const _hoisted_43 = {
  key: 0,
  class: "divide-y divide-gray-200 bg-white"
}
const _hoisted_44 = {
  key: 0,
  class: "relative w-12 px-6 sm:w-16 sm:px-8"
}
const _hoisted_45 = {
  key: 0,
  class: "absolute inset-y-0 left-0 w-0.5 bg-brand-500"
}
const _hoisted_46 = ["value"]
const _hoisted_47 = {
  class: "text-center w-full p-4",
  colspan: "100%"
}
const _hoisted_48 = {
  key: 1,
  class: "divide-y divide-gray-200 bg-white"
}
const _hoisted_49 = {
  colspan: "100%",
  class: "text-center whitespace-nowrap px-3 py-4 text-sm text-gray-500"
}
const _hoisted_50 = {
  class: "text-center w-full p-4",
  colspan: "100%"
}
const _hoisted_51 = {
  key: 0,
  class: "flex justify-center gap-3"
}

import {
		ref,
		computed
	} from 'vue'
	
	import {
		Dialog,
		DialogPanel,
		Disclosure,
		DisclosureButton,
		DisclosurePanel,
		Popover,
		PopoverButton,
		PopoverGroup,
		PopoverPanel,
		TransitionChild,
		TransitionRoot
	} from '@headlessui/vue'


	
// name the component
	const __default__ = { name: 'TwTable' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		checkable: {
			type: Boolean,
			default: false
		},
		data: {
			type: Array,
			default: () => {return []}
		},
		defaultSort: {
			type: Object,
			default: () => {return {prop: null, order: 'ASC'}}
		},
		description: {
			type: String,
			default: ""
		},
		filterable:{
			type: Boolean,
			default: false
		},
		filters:{
			type: Array[{label: String, options: Array}],
			default: () => {return []}
		},
		filterFunction:{
			type: Function,
			default: () => {return}
		},
		loading: {
			type: Boolean,
			default: false
		},
		multiRowActions: {
			type: Array, 
			default: () => {return []}
		},
		pageLength: {
			type: Number,
			default: null
		},
		placeholder: {
			type: String,
			default: "No Data"
		},
		rowActions: {
			type: Array,
			default: () => {return []}
		},
		searchable:{
			type: Boolean,
			default: false
		},
		searchMethod:{
			type: Function,
			default: () => {return}
		},
		searchPlaceholder: {
			type: String,
			default: "Search..."
		},
		title: {
			type: String,
			default: ""
		}
	},
  setup(__props, { expose }) {

const props = __props;

	expose({
		flipPage
	})

	

	

	const selectedRows = ref([])
	const indeterminate = computed(()=> selectedRows.value.length > 0 && selectedRows.value.length < currentPageData.value.length)
	const searchInput = ref('')

	/* Pagination */
	const countPages = computed(() => {
		return !props.pageLength ? 1 : Math.ceil((props.data.length) / props.pageLength)
	})
	const currentPage = ref<number>(1)
	const currentPageData = computed(() => {
		if(!props.pageLength) return props.data
		else return props.data.slice(props.pageLength * (currentPage.value - 1), props.pageLength * (currentPage.value - 1) + props.pageLength)
	})

	function flipPage (pageNumber : number) {
		if(!props.pageLength) {
			return 
		}
		// Guard Clauses
		if(pageNumber > countPages.value && countPages.value) {
			return 
		}
		if(!countPages.value) {
			currentPage.value = 1
			return
		}
		if(pageNumber < 1) {
			return 
		}

		currentPage.value = pageNumber
	}

	const currentSelectablePages = computed(() => {
		let selectablePages = []
		let startPage
		let endPage

		if(countPages.value <= 5){
			startPage = 1
			endPage = countPages.value
		}
		else {
			if((currentPage.value - 1) == 1){
				startPage = currentPage.value - 1
				endPage = currentPage.value + 3
			}
			else if((currentPage.value) == 1){
				startPage = currentPage.value
				endPage = currentPage.value + 4
			}
			else if(( currentPage.value + 1 ) == countPages.value){
				startPage = currentPage.value - 3
				endPage = currentPage.value + 1
			}
			else if((currentPage.value) == countPages.value){
				startPage = currentPage.value - 4
				endPage = currentPage.value
			}
			else{
				startPage = currentPage.value - 2
				endPage = currentPage.value + 2
			}
		}

		for( let i = startPage ?? 0 ; i <= (endPage ?? countPages.value) ; i++ ){
			selectablePages.push(i)
		}
		return selectablePages
	})

	// #region filters
	const filtersOpen = ref(true)

	/**
	 * The value of options selected for each filter
	 * @yields {array}
	 */
	const filterOptionsSelected = ref(props.filters.map(() => {return []}))

	/**
	 * The number of options selected for each filter
	 * @yields {array}
	 */
	const numFilterOptionsSelected = computed(() => {
		return filterOptionsSelected.value.map((options:[]) => {
			return options.length
		})
	})

	/**
	 * If the selected options for each filter is mixed checked/unchecked
	 * @yields {array}
	 */
	const filtersIndeterminate = computed(() => {
		return filterOptionsSelected.value.map((options:[], i:number) => {
			return options.length > 0 && options.length < props.filters[i].options.length
		})
	})

	/**
	 * Generates text to indicate how many filters are applied
	 * @yields {String}
	 */
	const filtersApplied = computed(() => {
		let numFiltersApplied = filterOptionsSelected.value.filter((options:[]) => {
			return options.length > 0
		}).length

		return `${numFiltersApplied || 'No'} Filter${numFiltersApplied !== 1 ? 's' : ''} Applied`
	})

	/**
	 * Runs filter function specified in the fitlers prop after selecting/deselecting all
	 * @function selectAll
	 * @param {Object} event - The event being fired
	 * @param {Number} filterIndex - The index of the filter being selected
	 */
	function selectAll(event:any, filterIndex:number) {
		filterOptionsSelected.value[filterIndex] = event.target.checked ? props.filters[filterIndex].options.map((o:{value:string,label:string}) => o.value) : []
		doFiltering()
	}

	/**
	 * Runs filter function specified in the fitlers prop. Function parameter in parent component is a 2d array of selected options
	 * @function doFiltering
	 */
	function doFiltering() {
		props.filterFunction(filterOptionsSelected.value)
	}

	// #endregion

return (_ctx: any,_cache: any) => {
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_ChevronDownIconMini = _resolveComponent("ChevronDownIconMini")!
  const _component_FunnelIconMini = _resolveComponent("FunnelIconMini")!
  const _component_MagnifyingGlassIcon = _resolveComponent("MagnifyingGlassIcon")!
  const _component_tw_table_dropdown = _resolveComponent("tw-table-dropdown")!
  const _component_tw_table_header = _resolveComponent("tw-table-header")!
  const _component_tw_table_row = _resolveComponent("tw-table-row")!
  const _component_tw_loading = _resolveComponent("tw-loading")!
  const _component_v_button = _resolveComponent("v-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_unref(currentPageData).length ? 'h-full' : ''])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          (__props.title)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(__props.title), 1))
            : _createCommentVNode("", true),
          (__props.description)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.description), 1))
            : _createCommentVNode("", true)
        ]),
        (__props.filterable)
          ? (_openBlock(), _createBlock(_unref(TransitionRoot), {
              key: 0,
              as: "template",
              show: filtersOpen.value
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Dialog), {
                  as: "div",
                  class: "relative z-40 sm:hidden",
                  onClose: _cache[2] || (_cache[2] = ($event: any) => (filtersOpen.value = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TransitionChild), {
                      as: "template",
                      enter: "transition-opacity ease-linear duration-300",
                      "enter-from": "opacity-0",
                      "enter-to": "opacity-100",
                      leave: "transition-opacity ease-linear duration-300",
                      "leave-from": "opacity-100",
                      "leave-to": "opacity-0"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_unref(TransitionChild), {
                        as: "template",
                        enter: "transition ease-in-out duration-300 transform",
                        "enter-from": "translate-x-full",
                        "enter-to": "translate-x-0",
                        leave: "transition ease-in-out duration-300 transform",
                        "leave-from": "translate-x-0",
                        "leave-to": "translate-x-full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DialogPanel), { class: "relative ml-auto flex h-full w-full max-w-xs flex-col overflow-y-auto bg-white py-4 pb-6 shadow-xl" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _hoisted_8,
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "-mr-2 flex h-10 w-10 items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brand-500",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (filtersOpen.value = false))
                                }, [
                                  _hoisted_9,
                                  _createVNode(_component_XMarkIcon, {
                                    class: "h-6 w-6",
                                    "aria-hidden": "true"
                                  })
                                ])
                              ]),
                              _createElementVNode("form", _hoisted_10, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filters, (filter, filterIndex) => {
                                  return (_openBlock(), _createBlock(_unref(Disclosure), {
                                    as: "div",
                                    key: filter.label,
                                    class: "border-t border-gray-200 px-4 py-6"
                                  }, {
                                    default: _withCtx(({ open }) => [
                                      _createElementVNode("h3", _hoisted_11, [
                                        _createVNode(_unref(DisclosureButton), { class: "flex w-full items-center justify-between bg-white px-2 py-3 text-sm text-gray-400" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", null, [
                                              _createElementVNode("span", _hoisted_12, _toDisplayString(filter.label), 1),
                                              _withDirectives(_createElementVNode("span", { class: "ml-1.5 rounded bg-gray-200 py-0.5 px-1.5 text-xs font-semibold tabular-nums text-gray-700" }, _toDisplayString(_unref(numFilterOptionsSelected)[filterIndex]), 513), [
                                                [_vShow, _unref(numFilterOptionsSelected)[filterIndex] > 0]
                                              ])
                                            ]),
                                            _createElementVNode("span", _hoisted_13, [
                                              _createVNode(_component_ChevronDownIconMini, {
                                                class: _normalizeClass([open ? '-rotate-180' : 'rotate-0', 'h-5 w-5 transform transition-all duration-300']),
                                                "aria-hidden": "true"
                                              }, null, 8, ["class"])
                                            ])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _createVNode(_unref(DisclosurePanel), { class: "space-y-2 divide-y divide-gray-200" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("input", {
                                              id: `filter-all-mobile-${filter.label}`,
                                              type: "checkbox",
                                              checked: _unref(filtersIndeterminate)[filterIndex] || filterOptionsSelected.value[filterIndex].length === filter.options.length,
                                              indeterminate: _unref(filtersIndeterminate)[filterIndex],
                                              onChange: (e) => selectAll(e, filterIndex),
                                              class: "h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-500"
                                            }, null, 40, _hoisted_15),
                                            _createElementVNode("label", {
                                              for: `filter-all-mobile-${filter.label}`,
                                              class: "ml-3 whitespace-nowrap pr-6 text-sm font-medium text-gray-900"
                                            }, " Select All ", 8, _hoisted_16)
                                          ]),
                                          _createElementVNode("div", _hoisted_17, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.options, (option, optionIdx) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: option.value + '-mobile',
                                                class: "flex items-center"
                                              }, [
                                                _withDirectives(_createElementVNode("input", {
                                                  id: `filter-mobile-${filter.label}-${optionIdx}`,
                                                  name: `${filter.label}`,
                                                  value: option.value,
                                                  "onUpdate:modelValue": ($event: any) => ((filterOptionsSelected.value[filterIndex]) = $event),
                                                  onChange: _cache[1] || (_cache[1] = ($event: any) => (doFiltering())),
                                                  type: "checkbox",
                                                  class: "h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-500"
                                                }, null, 40, _hoisted_18), [
                                                  [_vModelCheckbox, filterOptionsSelected.value[filterIndex]]
                                                ]),
                                                _createElementVNode("label", {
                                                  for: `filter-mobile-${filter.label}-${optionIdx}`,
                                                  class: "ml-3 text-sm text-gray-500"
                                                }, _toDisplayString(option.label), 9, _hoisted_19)
                                              ]))
                                            }), 128))
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["show"]))
          : _createCommentVNode("", true),
        (__props.filterable)
          ? (_openBlock(), _createElementBlock("section", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  type: "button",
                  class: "flex items-center group text-sm font-medium text-gray-700 sm:hidden",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (filtersOpen.value = true))
                }, [
                  _createVNode(_component_FunnelIconMini, {
                    class: "inline h-5 w-5 mr-1 text-gray-400 group-hover:text-gray-500",
                    "aria-hidden": "true"
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(filtersApplied)), 1)
                ]),
                _createVNode(_unref(PopoverGroup), { class: "hidden sm:flex sm:items-baseline sm:space-x-8" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_FunnelIconMini, {
                        class: "inline h-5 w-5 mr-1 text-gray-400",
                        "aria-hidden": "true"
                      }),
                      _createTextVNode(" " + _toDisplayString(_unref(filtersApplied)), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filters, (filter, filterIndex) => {
                      return (_openBlock(), _createBlock(_unref(Popover), {
                        as: "div",
                        key: filter.label,
                        id: `desktop-menu-${filterIndex}`,
                        class: "relative inline-block text-left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_unref(PopoverButton), { class: "group inline-flex items-center justify-center text-sm font-medium text-gray-700 hover:text-gray-900" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(filter.label), 1),
                                _withDirectives(_createElementVNode("span", { class: "ml-1.5 rounded bg-gray-200 py-0.5 px-1.5 text-xs font-semibold tabular-nums text-gray-700" }, _toDisplayString(_unref(numFilterOptionsSelected)[filterIndex]), 513), [
                                  [_vShow, _unref(numFilterOptionsSelected)[filterIndex] > 0]
                                ]),
                                _createVNode(_component_ChevronDownIconMini, {
                                  class: "-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500",
                                  "aria-hidden": "true"
                                })
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition ease-out duration-100",
                            "enter-from-class": "transform opacity-0 scale-95",
                            "enter-to-class": "transform opacity-100 scale-100",
                            "leave-active-class": "transition ease-in duration-75",
                            "leave-from-class": "transform opacity-100 scale-100",
                            "leave-to-class": "transform opacity-0 scale-95"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PopoverPanel), { class: "absolute right-0 z-10 mt-2 origin-top-right rounded-md bg-white py-3 shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("form", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                      _createElementVNode("input", {
                                        id: `filter-all-${filter.label}`,
                                        type: "checkbox",
                                        checked: _unref(filtersIndeterminate)[filterIndex] || filterOptionsSelected.value[filterIndex].length === filter.options.length,
                                        indeterminate: _unref(filtersIndeterminate)[filterIndex],
                                        onChange: (e) => selectAll(e, filterIndex),
                                        class: "h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-500"
                                      }, null, 40, _hoisted_26),
                                      _createElementVNode("label", {
                                        for: `filter-all-${filter.label}`,
                                        class: "ml-3 whitespace-nowrap pr-6 text-sm font-medium text-gray-900"
                                      }, " Select All ", 8, _hoisted_27)
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.options, (option, optionIdx) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: option.value,
                                          class: "flex items-center"
                                        }, [
                                          _withDirectives(_createElementVNode("input", {
                                            id: `filter-${filter.label}-${optionIdx}`,
                                            name: `${filter.label}[]`,
                                            value: option.value,
                                            "onUpdate:modelValue": ($event: any) => ((filterOptionsSelected.value[filterIndex]) = $event),
                                            onChange: _cache[4] || (_cache[4] = ($event: any) => (doFiltering())),
                                            type: "checkbox",
                                            class: "h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-500"
                                          }, null, 40, _hoisted_29), [
                                            [_vModelCheckbox, filterOptionsSelected.value[filterIndex]]
                                          ]),
                                          _createElementVNode("label", {
                                            for: `filter-${filter.label}-${optionIdx}`,
                                            class: "ml-3 whitespace-nowrap pr-6 text-sm font-medium text-gray-900"
                                          }, _toDisplayString(option.label), 9, _hoisted_30)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["id"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (__props.searchable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_MagnifyingGlassIcon, {
                  class: "h-5 w-5 text-gray-400",
                  "aria-hidden": "true"
                })
              ]),
              _hoisted_34,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "search",
                id: "search",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchInput).value = $event)),
                placeholder: __props.searchPlaceholder,
                onChange: _cache[6] || (_cache[6] = ($event: any) => (__props.searchMethod(searchInput.value))),
                class: "block rounded-md border-gray-300 pl-8 pr-12 shadow-sm focus:border-brand-500 focus:ring-brand-500 sm:text-sm w-full"
              }, null, 40, _hoisted_35), [
                [_vModelText, searchInput.value]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("table", _hoisted_40, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (__props.checkable)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_41, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "absolute left-4 top-1/2 -my-2 h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500 sm:left-6",
                            checked: _unref(indeterminate) || selectedRows.value.length === _unref(currentPageData).length,
                            indeterminate: _unref(indeterminate),
                            onChange: _cache[7] || (_cache[7] = ($event: any) => (selectedRows.value=$event.target?.checked ? _unref(currentPageData).map((r) => r.id) : []))
                          }, null, 40, _hoisted_42),
                          (selectedRows.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_tw_table_dropdown, {
                                key: 0,
                                class: "py-3 -mr-12 ml-4 pr-4",
                                items: __props.multiRowActions,
                                position: "left",
                                data: _unref(currentPageData),
                                "selected-table-rows": selectedRows.value
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_ChevronDownIconMini)
                                ]),
                                _: 1
                              }, 8, ["items", "data", "selected-table-rows"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_tw_table_header, { "default-sort": __props.defaultSort }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "default")
                      ]),
                      _: 3
                    }, 8, ["default-sort"])
                  ])
                ]),
                (_unref(currentPageData).length > 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_43, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentPageData), (row) => {
                        return (_openBlock(), _createElementBlock("tr", { key: row }, [
                          (__props.checkable)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_44, [
                                (selectedRows.value.includes(row.id))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_45))
                                  : _createCommentVNode("", true),
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  class: "absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500 sm:left-6",
                                  value: row.id,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedRows).value = $event))
                                }, null, 8, _hoisted_46), [
                                  [_vModelCheckbox, selectedRows.value]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_tw_table_row, { row: row }, {
                            default: _withCtx(() => [
                              _renderSlot(_ctx.$slots, "default")
                            ]),
                            _: 2
                          }, 1032, ["row"])
                        ]))
                      }), 128)),
                      _withDirectives(_createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_47, [
                          _createVNode(_component_tw_loading)
                        ])
                      ], 512), [
                        [_vShow, __props.loading]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_48, [
                      _withDirectives(_createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_49, _toDisplayString(__props.placeholder), 1)
                      ], 512), [
                        [_vShow, !__props.loading]
                      ]),
                      _withDirectives(_createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_50, [
                          _createVNode(_component_tw_loading)
                        ])
                      ], 512), [
                        [_vShow, __props.loading]
                      ])
                    ]))
              ])
            ])
          ])
        ])
      ])
    ], 2),
    (__props.pageLength && _unref(currentPageData).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _createVNode(_component_v_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (flipPage( (currentPage.value - 1 > 0) ? (currentPage.value - 1) : currentPage.value ))),
            class: "w-16 my-0",
            color: "white",
            plain: "",
            disabled: (currentPage.value == 1)
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Back ")
            ]),
            _: 1
          }, 8, ["disabled"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentSelectablePages), (page) => {
            return (_openBlock(), _createBlock(_component_v_button, {
              key: _unref(currentSelectablePages)[page],
              class: "w-8 my-0",
              plain: currentPage.value != page,
              color: currentPage.value === page ? 'amber' : 'white',
              onClick: ($event: any) => (flipPage(page))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(page), 1)
              ]),
              _: 2
            }, 1032, ["plain", "color", "onClick"]))
          }), 128)),
          _createVNode(_component_v_button, {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (flipPage( (currentPage.value + 1 <= _unref(countPages)) ? (currentPage.value + 1) : currentPage.value ))),
            class: "w-16 my-0",
            color: "white",
            plain: "",
            disabled: (currentPage.value == _unref(countPages))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Next ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})